import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import axios
import {getCSRFToken} from "../utils/auth"

const apiUrl = process.env.REACT_APP_API_URL;

const AgentsContent = () => {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const csrf_token = getCSRFToken()

    useEffect(() => {
        const fetchAgents = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${apiUrl}/ai/api/agent/`, { 
                withCredentials: true, 
                headers: {
                  'X-CSRFToken': csrf_token,  
                } 
              }); // Make the API call
                console.log(response);
                setAgents(response.data.agents); // Set the fetched data
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchAgents();
    }, [csrf_token]); // Run only once on component mount

    if (loading) {
        return <div className="p-6">Loading agents...</div>;
    }

    if (error) {
        return <div className="p-6">Error loading agents: {error.message}</div>;
    }

    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">Agent Management</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {agents.map((agent) => (
                    <AgentCard key={agent.id} agent={agent} /> // Pass agent object
                ))}
            </div>
        </div>
    );
};

const AgentCard = ({ agent }) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="font-medium">{agent.name || `Agent ${agent.name} (${agent.id})`}</h3> 
            {/*<p className="text-gray-500 text-sm mt-2">Status: {agent.status || 'Unknown'}</p> */}
            <p className="text-gray-500 text-sm mt-2">AI Platform/ model: {agent.agent_type || 'Unknown'}</p> 
            <p className="text-gray-500 text-sm mt-2">Configuration:  <pre>{JSON.stringify(agent.configuration, null, 2)  || 'Unknown'}</pre></p> 
            <div className="mt-4 flex justify-end">
                <button className="text-blue-500 text-sm">Manage</button>
            </div>
        </div>
    );
};

export default AgentsContent;